import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'query-string';

import { getTranslate } from 'react-localize-redux';
import { routerActions } from 'react-router-redux';
import { Row, Col } from 'react-flexbox-grid';
import Input from 'react-toolbox/lib/input';
import Checkbox from 'react-toolbox/lib/checkbox';

import ProjectActions from '../actions/project.actions';
import WizardActions from '../actions/wizard.actions';
import Button from '../common/ButtonComp';

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class SeoPerfomanceComp extends Component {
  state = {
    slideIdx: 0,
    email: null,
    seoEmails: '',
    sendSeoPerformanceEmail: true
  };

  constructor(props) {
    super(props);

    const { user, project, query } = this.props;

    const { email, contactEmail } = user;
    const { idx = 0 } = query;
    const { sendSeoPerformanceEmail = true } = project;

    this.state = {
      ...this.state,
      seoEmails: project.seoEmails || '',
      sendSeoPerformanceEmail
    };
  }

  componentDidMount() {
    const {
      query: { idx = 0 },
      routerActions,
      project
    } = this.props;
    if (project.wizard[3] !== 'create-datapoints')
      routerActions.push(`create-datapoints?idx=${idx}`);
  }

  goBack() {
    const { idx = 0 } = this.props.query;
    this.props.routerActions.push(`create-datapoints?idx=${idx}`);
  }

  goNext() {
    const { project, wizardActions, projectActions } = this.props;
    const { seoEmails, sendSeoPerformanceEmail } = this.state;
    const cb = () => {
      projectActions.setSeoPerfomanceEmails({
        id: project._id,
        seoPerfEmails: seoEmails,
        sendSeoPerformanceEmail
      });
    };

    wizardActions.wizardDone({ id: project._id, cb });
  }

  handleChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  render() {
    const { query, wizard, translate } = this.props;
    const { idx = 0 } = query;

    const contactEmailField = (
      <Row center="xs" className="space-medium-bottom">
        <Col xs={12}>
          <Input
            type="text"
            label={translate('wizard.seo_perfomance.contact_email')}
            value={this.state.seoEmails}
            onChange={this.handleChange.bind(this, 'seoEmails')}
          />
        </Col>
      </Row>
    );

    const seoMailCheckBox = (
      <Row center="xs" className="space-medium-bottom">
        <Col xs={4}>
          <Checkbox
            checked={this.state.sendSeoPerformanceEmail}
            onChange={this.handleChange.bind(this, 'sendSeoPerformanceEmail')}
            label={translate('wizard.seo_perfomance.weekly_seo_email')}
          />
          {this.state.sendSeoPerformanceEmail && contactEmailField}
        </Col>
      </Row>
    );

    const seoEmailsInvalid = !this.state.seoEmails
      .split(/[,\s]/)
      .filter((x) => x.length > 0)
      .reduce((r, x) => r && emailRegex.test(x), true);

    return (
      <div>
        <h1 className="space-big-bottom">{translate('wizard.seo_perfomance.title')}</h1>

        <Row center="xs" className="space-medium-bottom">
          <Col xs={6}>
            {`The weekly SEO performance mails provide you with an update on your most important stats via email.`}
          </Col>
        </Row>

        {seoMailCheckBox}

        <div className="kwh-button-group">
          <Button big secondary onClick={this.goBack.bind(this)}>
            {translate('app.back')}
          </Button>
          <Button
            big
            primary
            onClick={this.goNext.bind(this)}
            disabled={seoEmailsInvalid}
            loading={this.props.wizard.saving}
          >
            {translate('app.done')}
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    routing: {
      location: { search }
    },
    me: { user },
    wizard
  } = state;

  const { projects = [] } = state.me.user;
  const query = search ? qs.parse(search) : { idx: 0 };

  return {
    query,
    user,
    wizard,
    translate: getTranslate(state.locale),
    project: projects.find(({ index }) => index === Number(query.idx))
  };
};

const mapDispatchToProps = (dispatch) => ({
  projectActions: bindActionCreators(ProjectActions, dispatch),
  wizardActions: bindActionCreators(WizardActions, dispatch),
  routerActions: bindActionCreators(routerActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SeoPerfomanceComp);



// WEBPACK FOOTER //
// ./src/wizard/SeoPerfomanceComp.js